module.exports = __webpack_public_path__ + "img/bingo_ball-6.7e305149.png";